import { useEffect, useState } from 'react'
import { Link, useOutletContext } from 'react-router-dom'

import { listConfigTesters, stopConfigTester } from '../../../api/configTesters.js'

const STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'active', label: 'Active' },
  { value: 'off', label: 'Off' },
]

function formatDate(value) {
  if (!value) return ''
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return String(value)
  return parsed.toLocaleString()
}

export default function ApplicationConfigTesterListPage() {
  const { applicationId } = useOutletContext()
  const [statusFilter, setStatusFilter] = useState('')
  const [state, setState] = useState({
    status: 'loading',
    data: [],
    error: null,
  })
  const [stoppingId, setStoppingId] = useState(null)

  function load() {
    setState((prev) => ({ ...prev, status: 'loading', error: null }))
    listConfigTesters(applicationId, statusFilter)
      .then((items) => setState({ status: 'ok', data: items, error: null }))
      .catch((error) => setState({ status: 'error', data: [], error }))
  }

  useEffect(() => {
    load()
  }, [applicationId, statusFilter])

  async function handleStop(item) {
    if (stoppingId) return
    if (!window.confirm(`Stop config tester ${item.qaId}?`)) return
    try {
      setStoppingId(item.id)
      await stopConfigTester(applicationId, item.id)
      load()
    } catch (err) {
      alert(String(err?.message || err))
    } finally {
      setStoppingId(null)
    }
  }

  return (
    <section className="card sectionCard">
      <div className="pageHeader pageHeaderTight">
        <div>
          <div className="cardTitle">Config Tester</div>
        </div>
        <div className="buttonGroup">
          <select
            className="textInput selectFilter"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            aria-label="Filter by config tester status"
          >
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value || 'all'} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <Link to={`/applications/${applicationId}/config-tester/new`} className="button buttonPrimary">
            Create
          </Link>
        </div>
      </div>

      {state.status === 'loading' ? (
        <p className="muted inlineMessage">Loading config testers...</p>
      ) : null}

      {state.status === 'error' ? (
        <pre className="codeBlock codeBlockError">{String(state.error?.message || state.error)}</pre>
      ) : null}

      {state.status === 'ok' && state.data.length === 0 ? (
        <p className="muted inlineMessage">No config testers yet.</p>
      ) : null}

      {state.status === 'ok' && state.data.length > 0 ? (
        <table className="table" aria-label="Config testers list">
          <thead>
            <tr>
              <th>QA ID</th>
              <th>Remote config</th>
              <th>Segmentation</th>
              <th>Status</th>
              <th>Started</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {state.data.map((item) => (
              <tr key={item.id}>
                <td className="mono">{item.qaId}</td>
                <td>{item.remoteConfigName || item.remoteConfigId || ''}</td>
                <td>{item.segmentationName || ''}</td>
                <td>{item.isActive ? 'Active' : 'Off'}</td>
                <td>{formatDate(item.startTime || item.createdAt)}</td>
                <td>{item.description}</td>
                <td>
                  <div className="buttonGroup">
                    <Link
                      to={`/applications/${applicationId}/config-tester/${item.id}`}
                      className="button buttonGhost"
                    >
                      View
                    </Link>
                    {item.isActive ? (
                      <button
                        type="button"
                        className="button buttonGhost buttonDanger"
                        disabled={stoppingId === item.id}
                        onClick={() => handleStop(item)}
                      >
                        {stoppingId === item.id ? 'Stopping...' : 'Stop'}
                      </button>
                    ) : null}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </section>
  )
}
